//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    const pulldownDefaultConfig = {
        content: '下拉刷新',
        height: 40,
        autoRefresh: false,
        downContent: '下拉刷新',
        upContent: '释放后刷新',
        loadingContent: '正在刷新...',
        clsPrefix: 'xs-plugin-pulldown-'
    }
    const pullupDefaultConfig = {
        content: '上拉加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
    }
    // import BScroll from "better-scroll";
    export default {
        name: 'leave_custom_list',
        data () {
            return {
                // results: [],
                keyword: '',
                panel_type: '1',
                memberList: [],
                page: '1',
                pullupDefaultConfig: pullupDefaultConfig,
                pulldownDefaultConfig: pulldownDefaultConfig
            }
        },
        methods: {
            go_live_custom(){
                this.$router.push({
                    path: './maternal_file',
                })
            },
            panelClick(item){
                console.info(item)
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        id:item.id
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //点击搜索
            searchBtn(){
                this.refresh()
                // this.$nextTick(() => {
                //     that.$refs.scrollerBottom.reset({top: 0})
                //     that.refresh()
                // })
            },
            //清空搜索
            clearSearch(){
                this.keyword = ''
                this.refresh()
            },
            //请求数据
            apiMemberList(str){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let that = this
                let params = {
                    token: this.$cookie.get('token'),
                    keyword:this.keyword,
                    page:this.page
                }
                console.info(params)
                Api.memberListApi.leaveCustom(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.page++
                        this.$nextTick(() => {
                            that.$refs.scrollerBottom.reset()
                        })
                        if(res.data.list.length){
                            for(let item of res.data.list){
                                let _desc = '电话：'+ item.phone + '&nbsp;&nbsp;&nbsp;&nbsp;房号：' + item.room_name
                                let options = {
                                    id: item.maternal_info_id,
                                    src: require('../assets/user1.png'),
                                    fallbackSrc: require('../assets/user1.png'),
                                    title: item.member_name,
                                    desc: _desc,
                                    phone: item.phone
                                }
                                this.memberList.push(options)
                                this.$refs.scrollerBottom.donePullup()
                            }
                            if(str == 'refresh'){
                                this.$refs.scrollerBottom.enablePullup()//启用上拉加载插件
                                this.$refs.scrollerBottom.donePulldown()//设置下拉刷新操作完成，在数据加载后执行
                            }
                            if( res.data.page.record_page == res.data.page.page_count){
                                this.$refs.scrollerBottom.disablePullup()// 禁用上拉加载，在没有更多数据时执行
                            }else{
                                this.$refs.scrollerBottom.donePullup()//设置上拉加载操作完成，在数据加载后执行
                            }
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // //下拉刷新
            refresh() {
                this.memberList= []
                this.page = '1'
                // this.floor_arr = []
                this.apiMemberList('refresh')
            },
            // //上拉加载
            loadMore() {
                this.apiMemberList()
            },
        },
        created (){
            let that = this
            this.$nextTick(() => {
                that.$refs.scrollerBottom.reset({top: 0})
            })
            this.apiMemberList()
        }
    }



// WEBPACK FOOTER //
// ./src/components/leave_custom_list.vue